// Route/tab key enums for the Client & Contact and Matter detail pages. They lived in Tab.tsx
// alongside the Semantic-backed RvTab, so importing them pulled Semantic UI into both pages.
export enum TabEnum {
    GENERALINFORMATION = 0,
    FINANCIALS = 1,
    MATTERS = 2,
    CONTACTS = 3,
    MESSAGES_AND_NOTES = 4,
    WEBSITE = 5,
    NEWS = 6,
    REFERRALS = 7,
    MATTERS_REFERRED = 8,
    STAFF = 9,
    DOCUMENTS = 10,
    TIMELINE = 11,
    TOPICS = 12,
    PARTIES = 13,
    TASKS = 14,
    DASHBOARD = 15,
    RELATIONSHIP = 16
}

export enum TabEnumMatter {
    STAFF = 0,
    GENERALINFORMATION = 1,
    FINANCIALS = 2,
    MATTERS = 3,
    CONTACTS = 4,
    MESSAGES_AND_NOTES = 5,
    WEBSITE = 6,
    NEWS = 7,
    REFERRALS = 8,
    MATTERS_REFERRED = 9,
    DOCUMENTS = 10,
    TIMELINE = 11,
    TOPICS = 12,
    PARTIES = 13,
    TASKS = 14
}
